export default class FormController {
    constructor() {
        if (document.querySelectorAll('main form').length) {
            this.init();
        }
    }

    init() {
        document.querySelectorAll('main form').forEach(form => {
            if (form.querySelectorAll('.donationAmountOption').length && form.querySelectorAll('.donationAmountCustomInput')) {
                this.initDonationOptions(form);
            }
            if (form.querySelectorAll('.honey')) {
                form.querySelectorAll('.honey').required = false;
            }
        });
    }

    initDonationOptions(form) {
        form.querySelectorAll('.donationAmountOption').forEach(option => {
            option.querySelector('input').addEventListener('change', e => {
                let type = option.dataset.type;
                
                if (Array.from(form.querySelectorAll(`.donationAmountOption[data-type="${type}"]`)).filter(option => option.querySelector('input').checked).length) {
                    // Option is selected, clear custom if available
                    if (form.querySelector(`.donationAmountCustomInput[data-type="${type}"] input`)) {
                        form.querySelector(`.donationAmountCustomInput[data-type="${type}"] input`).value = '';
                        $(form).validate();
                    }
                }
            });
        });

        form.querySelectorAll('.donationAmountCustomInput').forEach(customOption => {
            let type = customOption.dataset.type;

            const checkFunc = () => {
                if (customOption.querySelector('input').value.trim() != '') {
                    form.querySelectorAll(`.donationAmountOption[data-type="${type}"] input`).forEach(optionInput => {
                        optionInput.checked = false;
                    });
                }
            };

            ['keypress', 'keydown', 'input', 'blur', 'focus', 'click', 'mouseleave', 'paste', 'cut'].forEach(event => {
                customOption.querySelector('input').addEventListener(event, checkFunc);
            });
        });
    }
}